const styles = (theme) => {
    return {
        patients: {
            width: 1000,
        },

        patients__icon: {
            display: 'block',
            color: theme.palette.text.secondary,
        },
    };
};

export default styles;
